import { Download, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

export function InstallAppBanner() {
  const { t } = useTranslation(["pwaInstall"]);
  const { canInstall, promptInstall, dismiss } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={t("pwaInstall:bannerLabel")}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={dismiss}
    >
      <div
        className="relative w-full max-w-sm rounded-xl border border-border bg-card p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={dismiss}
          aria-label={t("pwaInstall:dismiss")}
          className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
        >
          <X className="h-5 w-5" />
        </button>
        <Download className="h-8 w-8 text-primary" />
        <p className="mt-3 text-base font-semibold text-foreground">
          {t("pwaInstall:title")}
        </p>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("pwaInstall:description")}
        </p>
        <button
          type="button"
          onClick={promptInstall}
          className="mt-4 w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          {t("pwaInstall:install")}
        </button>
      </div>
    </div>
  );
}
